<template>
  <article>
    <p>Create a FREE Account or Login for access to all 35 Senate and 435 House forecasting pages</p>

    <v-dialog
      v-model="showLoginDialog"
      max-width="800"
      persistent>
      <template v-slot:activator="{on, attrs}">
        <div class="text-center">
          <v-btn
            v-on="on"
            v-bind="attrs"
            plain
            text
            color="primary">
            <v-icon>mdi-login</v-icon>
            Login
          </v-btn>
        </div>
      </template>

      <v-card>
        <v-card-title
          class="headline primary white--text justify-space-between"
          style="word-break: break-word; gap: 1em;">
          <span>Create a FREE Account</span>

          <v-btn
            @click="closeLoginDialog"
            icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-8">
          <LoginSignup />

          <v-divider class="mt-4"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="closeLoginDialog"
              plain
              text
              color="error">
              No Thanks
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <hr class="my-2">
  </article>
</template>

<script>
import {
  setCookie,
  MAX_COOKIE_EXPIRATION,
} from "@/mixins/cookies";

const components = {
  LoginSignup: () => import("@/components/LoginSignup"),
};

const methods = {
  closeLoginDialog() {
    this.showLoginDialog = false;
    setCookie(this.dialogDismissedCookieName, "true", MAX_COOKIE_EXPIRATION);
  },
};

export default {
  components,
  methods,
  data: () => ({
    dialogDismissedCookieName: "login-dialog-dismissed",
    showLoginDialog: false,
  }),
};
</script>
